<template>
    <v-container fluid>
        <resource-form
            :model="model"
            @saved="saved"
            :titlePrefix="$t('roles.create.texts.title-prefix')"
            :isEdit="false"
        ></resource-form>
    </v-container>
</template>

<script>
import Model from '@/models/Role'
import Form from './Form'

export default {
    components: {
        'resource-form': Form,
    },

    data: () => {
        return {
            model: new Model(),
        }
    },

    methods: {
        saved() {
            this.$router.push({ name: this.$t('roles.routes.index') })
        },
    },
}
</script>
